<template>
	<HeroComponent>




		<template v-slot:hero-image>
			<div class="background-banner-earn-page w-100 h-100 d-flex flex-row justify-center"
				style="position: relative;">
				<money-stash class="h-100 earning-quest-banner__hero-image-item1"></money-stash>
				<earn-quest-banner-additional-elements
					class="h-100 earning-quest-banner__hero-image-item2"></earn-quest-banner-additional-elements>
				<v-img :src="AppConfigs.staticImages.HANDWITHGOLDENCOINSLYINGPALM" v-if="isDesktopDevice"
					class="earning-quest-banner__hero-image-item3"></v-img>
			</div>
		</template>

		<template v-slot:hero-title>
			Earning Quest
		</template>

		<template v-slot:hero-subtitle>
			Explore various ways to earn real cash.
		</template>




	</HeroComponent>
</template>



<script setup>

import { AppConfigs } from "@/app.configs";
import MoneyStash from '@/icons/EarnQuestBannerMoneyStash.vue';
import { isMobile, isDesktop, isTablet } from "@/utils/utils.ts";
import HeroComponent from '@/components/Common/Hero-Component.vue';
import EarnQuestBannerAdditionalElements from '@/icons/EarnQuestBannerAdditionalElements.vue';

const isDesktopDevice = isDesktop();

</script>

<style scoped lang="scss">
@use "@/assets/scss/components/Earn/earning-quest-banner.scss";
</style>